import axios from 'axios'

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
})

api.defaults.headers.common['Content-Type'] = 'application/json'
api.defaults.headers.common.Accept = 'application/json'

// Axios 1.x keeps the default application/json even for FormData, which breaks
// multipart uploads (multer never sees the file; fields land in req.body).
api.interceptors.request.use(config => {
  if (typeof FormData !== 'undefined' && config.data instanceof FormData && config.headers) {
    const headers = config.headers as {
      delete?: (name: string) => void
      set?: (name: string, value?: string) => void
      common?: Record<string, unknown>
      [key: string]: unknown
    }
    if (typeof headers.delete === 'function') {
      headers.delete('Content-Type')
    } else {
      delete headers['Content-Type']
      if (headers.common) {
        delete headers.common['Content-Type']
      }
    }
  }
  return config
})

const setAuthHeader = (token: string) => {
  api.defaults.headers.common.Authorization = `Bearer ${token}`
}

const removeAuthHeader = () => {
  delete api.defaults.headers.common.Authorization
}

export { api, setAuthHeader, removeAuthHeader }
